export default __webpack_public_path__ + "static/media/small-logo.ed40b378.svg";